import { useEffect } from 'react';
import { useListingAgreements } from '@/views/Home/hooks';
import {
  TrackHomePageEvent,
  useTrackHomePageAnalytics,
} from '$analytics/useTrackAnalytics/domains/homePage';
import {
  InteractionSelectionModal,
  type InteractionSelectionModalProps,
} from './InteractionSelectionModal';

interface Props
  extends Pick<InteractionSelectionModalProps, 'numItems' | 'open'> {
  onClose: () => void;
}

export const ListingAgreementInteractionModal = ({
  numItems,
  onClose,
  open,
}: Props) => {
  const trackEvent = useTrackHomePageAnalytics();
  const { listingAgreementInteractions, loading, onLoadMore } =
    useListingAgreements({ skip: !open });

  const handleClose = (eventTarget: string) => {
    onClose();
    trackEvent(TrackHomePageEvent.NeedsAttentionModalClose, { eventTarget });
  };

  useEffect(() => {
    if (open) {
      trackEvent(TrackHomePageEvent.NeedsAttentionModalMount);
    }
  }, [open, trackEvent]);

  return (
    <InteractionSelectionModal
      onClose={handleClose}
      loading={loading}
      numItems={numItems}
      interactions={listingAgreementInteractions}
      open={open}
      modalSubtitle="There are multiple transactions that have listing agreements that are expiring within the next week"
      onLoadMore={onLoadMore}
    />
  );
};
